module.exports = __webpack_public_path__ + "static/img/A (12).5ed45e4a.png";